import { Host, h } from '@stencil/core';
// import { data } from './_mock/concernBlock.json';
// import { donutAnalysis } from './_mock/donutAnalysis.json';
export class AibaAnalysisConcernBlock {
  constructor() {
    this.data = undefined;
    this.mockData = undefined;
    this.handlers = undefined;
    this.styles = undefined;
    this.donutData = undefined;
  }
  async componentWillLoad(event) {
    if (this.handlers && this.handlers.handleConernBlockComponentWillLoad) {
      const response = await this.handlers.handleConernBlockComponentWillLoad(this.data, event);
      this.donutData = response.donutData;
    }
    else {
      if (typeof this.mockData === 'string') {
        this.donutData = JSON.parse(this.mockData);
      }
    }
  }
  render() {
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    return (h(Host, null, h("div", { class: "aiba-analysis-concern-block-wrapper" }, this.data &&
      this.data.elements.map((element) => {
        if (element.name === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element['data']));
        }
        if (element.name === 'aiba-donut-view') {
          return (h("div", { class: "aiba-donut-view" }, element.data &&
            element.data.elements.map((item) => {
              var _a, _b;
              {
                return (item.name === 'aiba-donut' &&
                  ((_b = (_a = this.donutData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map((dountInfo) => {
                    return (h("aiba-donut", { handleClick: (event) => this.handlers && this.handlers.handleDonutClick && this.handlers.handleDonutClick(dountInfo.algorithmTechName, event), value: (dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value) ? dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value : dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.value, content: dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.info, variant: dountInfo === null || dountInfo === void 0 ? void 0 : dountInfo.status, data: item['data'], key: dountInfo.algorithmTechName }));
                  })));
              }
            })));
        }
      }))));
  }
  static get is() { return "aiba-analysis-concern-block"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-analysis-concern-block.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-analysis-concern-block.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "mockData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "mock-data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "styles": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "donutData": {}
    };
  }
}
//# sourceMappingURL=aiba-analysis-concern-block.js.map
